import React from 'react';
import '../../CustomModule.css';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function NumberPercentage({
  textColour,
  name,
  placeHolder,
  label,
  charCount,
  maxCount,
  onlyRead,
  fromForm,
  duplicatingItem,
  editingInput,
  gridIndex,
  pageIndex,
  value,
  onChange,
  disable,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  isColourCoding,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const combinedStyles = getControlStyle(otherConfiguration);
  return (
    <div className="number-input">
      <label htmlFor={name} className={`asterisk-req fs-custom-module ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>
        {label}
      </label>
      <input
        type="number"
        name={name}
        placeholder={placeHolder}
        className={`form-control ${(isColourCoding && textColour) || ''}`}
        disabled={disable}
        readOnly={onlyRead}
        value={value}
        style={combinedStyles}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value, label, gridIndex, pageIndex)}
      />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
      {charCount && <div className="text-count">0/{maxCount}</div>}
    </div>
  );
}
export default NumberPercentage;
